<div class="form-group row invisible-border" *ngIf="playlistItem.RssConfigs" [class]="className">
  <label for="RssUrl" class="col-md-3 pr-0 dynamic-width" matTooltip="Playlist item ticker">Ticker
    (RSS or free text)</label>

  <div class="row no-gutters col-md-5 align-items-center pl-1 m-0 file-uploader" *ngIf="playlistItem.RssConfigs.FileName; else rssInput">
    <div class="col-md-1 d-flex">
      <mat-icon svgIcon="rss_file"></mat-icon>
    </div>
    <div class="col-md-8 dynamic-width">
      <span class="font-weight-normal pl-1" [matTooltip]="playlistItem.RssConfigs.FileName">
        {{ playlistItem.RssConfigs.FileName }}
      </span>
    </div>
    <div class="col-md-3 d-flex justify-content-end">
      <mat-icon svgIcon="close" (click)="onRemoveRss()" matTooltip="Remove RSS File"></mat-icon>
      <mat-icon svgIcon="setting" *ngIf="playlistItem.RssConfigs.FileId" class="ml-1"
        matTooltip="Configure Ticker" (click)="onConfigureRSSTicker(playlistItem)"></mat-icon>
    </div>
  </div>
  <ng-template #rssInput>
    <input type="text" class="col-md-5" [(ngModel)]="playlistItem.RssConfigs.Url" id="RssUrl" [placeholder]="rssInputPlaceholder"
      name="RssUrl">
  </ng-template>
  <div class="d-flex align-items-center h-100">
    <label class="upload" *ngIf="!playlistItem.RssConfigs.FileId">
      <input class="d-none" type="file" ngFileSelect [options]="options" (uploadOutput)="onUploadRSS($event)"
        [accept]="rssFileTypes" [uploadInput]="uploadInput">
      <mat-icon *ngIf="!playlistItem.RssConfigs.FileName" svgIcon="upload" matTooltip="Upload RSS file"></mat-icon>
    </label>
    <mat-icon *ngIf="playlistItem.RssConfigs.Url" class="ml-1" svgIcon="setting"
      matTooltip="Configure Ticker" (click)="onConfigureRSSTicker(playlistItem)"></mat-icon>
  </div>
</div>
